import { userSlice } from './reducer'
import {
  handleAuthenticate,
  handleLogout,
  handleResetPassword,
  uploadBulkEntry,
  getUploadedFiles,
  downloadStudentActivity
} from './api'

const {
  updateIsLoggedIn,
  updateUserName,
  updatePassword,
  updateHasError,
  updateSelectedBatch,
  updateSelectedCourse,
  updateStudentActivity
} = userSlice.actions

export {
  updateIsLoggedIn,
  updateUserName,
  updatePassword,
  handleAuthenticate,
  handleLogout,
  updateHasError,
  updateSelectedBatch,
  updateSelectedCourse,
  handleResetPassword,
  uploadBulkEntry,
  getUploadedFiles,
  updateStudentActivity,
  downloadStudentActivity
}
